export default __webpack_public_path__ + "static/media/TN.5054440d.svg";